export default __webpack_public_path__ + "static/media/Anktar Longshot.d8c6e0fe.jpg";